import { createContext, useContext } from 'react';
import * as appFormSchema from 'yup';

export { appFormSchema };

export const AppFormSchemaContext = createContext<appFormSchema.ObjectSchema>(appFormSchema.object());

export function useAppFormSchema() {
  return useContext(AppFormSchemaContext);
}
